/* First-party enhancement only. The static preview never emits this marker.
 * Shopify Liquid emits it exclusively after a successful native customer POST.
 * Never infer success from clicks, submissions, query strings or stored data.
 */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.RitualSignupRedirectStarted) return;
  var links = Array.from(document.querySelectorAll('[data-ritual-signup-confirmed] a[data-ritual-signup-redirect]'));
  if (!links.length) return;
  var fragment;
  try { fragment = decodeURIComponent(window.location.hash.slice(1)); } catch (_) { fragment = ''; }
  var link = links.find(function (candidate) {
    var form = candidate.closest('form');
    return form && form.id === fragment;
  }) || links[0];
  var destination;
  try { destination = new URL(link.getAttribute('href'), window.location.origin); } catch (_) { return; }
  if (!/^https?:$/.test(destination.protocol) || destination.origin !== window.location.origin || destination.username || destination.password ||
      !/\/pages\/thank-you$/.test(destination.pathname) || destination.search || destination.hash) return;
  // Follow the confirmation link. Never append contact/email values or query strings.
  window.RitualSignupRedirectStarted = true;
  var navigated = false;
  function navigate() {
    if (navigated) return;
    navigated = true;
    window.location.replace(destination.href);
  }
  if (window.RitualAnalyticsEvents) {
    // An independent deadline also protects navigation if the event adapter fails.
    window.setTimeout(navigate, 800);
    try { window.RitualAnalyticsEvents.afterSignup(navigate); } catch (_) { navigate(); }
  } else navigate();
}());
